<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
     <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
  
    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>RYB Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="singlePhaseAll[0].rybSn.serialNumber" readonly> </v-text-field>
        </v-col>
        <v-col cols="1">
           <v-checkbox
      v-model="checkbox"
      label="Change ?"
    ></v-checkbox>
        </v-col>
        <v-col cols="2" v-if="checkbox === true">
           <v-select  
            :items="serialNumber"
            item-value="_id"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="singlePhase[0].rybSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>RYB Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="singlePhase[0].rybConsole"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="singlePhase[0].boardName"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Smart Meter Reading Number Now</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field type="Number" v-model="singlePhase[0].meter"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

    <v-card-title>Phase R</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase R Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="singlePhase[0].rybSnR"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase R Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="singlePhase[0].rybConsoleR"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

   <v-card-title>Phase Y</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Y Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="singlePhase[0].rybSnY"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Y Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="singlePhase[0].rybConsoleY"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

    <v-card-title>Phase B</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase B Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="singlePhase[0].rybSnB"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase B Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="singlePhase[0].rybConsoleB"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Single Phase',
          disabled: false,
          href: '/single-phase',
        },
        {
          text: 'Details',
          disabled: false,
          href: '/single-phase/details/'+this.$route.params.id,
        },
        {
          text: 'Edit',
          disabled: true,
          href: '',
        },
      ],
    checkbox: false,
    singlePhase: [],
    singlePhaseAll: [],

    valid: true,
    serialNumber: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsSerialNumber();
      this.loadsSinglePhase();
      this.loadsSinglePhaseAll();
  },
  methods: {
    loadsSinglePhase: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/single-phase/"+this.$route.params.id;
    axios.get(apiURL).then(res => {
    this.singlePhase = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    loadsSinglePhaseAll: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/single-phase-all/"+this.$route.params.id;
    axios.get(apiURL).then(res => {
    this.singlePhaseAll = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    loadsSerialNumber: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-available";
    axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/update-single-phase/" + this.$route.params.id;
      axios
        .post(
      apiURL,
          {
    rybSn: this.singlePhase[0].rybSn,
    rybConsole: this.singlePhase[0].rybConsole,
    boardName: this.singlePhase[0].boardName,
    meter: this.singlePhase[0].meter,
    rybSnR: this.singlePhase[0].rybSnR,
    rybConsoleR: this.singlePhase[0].rybConsoleR,
    rybSnY: this.singlePhase[0].rybSnY,
    rybConsoleY: this.singlePhase[0].rybConsoleY,
    rybSnB: this.singlePhase[0].rybSnB,
    rybConsoleB: this.singlePhase[0].rybConsoleB,

    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>